import { VERSION } from "@angular/core";
import { AutoComplete } from "primeng/autocomplete";

if (VERSION.major === "19") {
  AutoComplete.prototype.onInputBlur = function (this: AutoComplete, event: Event): void {
    this.dirty = false;
    this.focused = false;
    this.focusedOptionIndex.set(-1);

    // https://github.com/primefaces/primeng/commit/a9cc50ec03c150e5cb7217551bdb7da55ff9a2f5#diff-a627e2e852685d803c6218638438c96993a7df589b270f6393e6fbe5959625b5R1241-R1252
    if (this.multiple && !this.typeahead) {
      const inputValue = (
        this.multiInputEl?.nativeElement?.value ||
        (<HTMLInputElement>event.target).value ||
        ""
      ).trim();
      if (inputValue && !this.isSelected(inputValue)) {
        this.updateModel([...(this.modelValue() || []), inputValue]);
        if (this.multiInputEl?.nativeElement) {
          this.multiInputEl.nativeElement.value = "";
        } else {
          (<HTMLInputElement>event.target).value = "";
        }
      }
    }

    this.onModelTouched();
    this.onBlur.emit(event);
  };
} else {
  // eslint-disable-next-line no-console
  console.warn("Skipping the autocomplete fix — it only works for PrimeNG 19 and might be obsolete now.");
}
